import { render, staticRenderFns } from "./ModelsIcon.vue?vue&type=template&id=8b9dd032&"
import script from "./ModelsIcon.vue?vue&type=script&lang=js&"
export * from "./ModelsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports